import alt from 'alt'
import { createStore, datasource, bind } from 'alt-utils/lib/decorators'
import { SearchConsoleActions } from 'actions'

@createStore(alt)
export default class SearchConsoleStore {
  static displayName = 'SearchConsoleStore'

  constructor() {
    this.state = {
      listedSites: [],
      consoleStatus: undefined,
      consoleSetupError: undefined,
      searchAnalyticsQuery: {}
    }

    this.bindActions(SearchConsoleActions)
  }

  setListedSites(listedSites) {
    this.setState({ listedSites })
  }

  setConsoleSetupError(consoleSetupError) {
    this.setState({ consoleSetupError })
  }

  setConsoleStatus(consoleStatus) {
    this.setState({ consoleStatus })
  }

  setSearchAnalyticsQuery(searchAnalyticsQuery) {
    this.setState({ searchAnalyticsQuery })
  }
}



// WEBPACK FOOTER //
// ./app/stores/SearchConsoleStore.js